import React, { useState, useEffect, useRef } from "react";

export default function Footer() {
  const [textSize, setTextSize] = useState("medium");
  const [isReading, setIsReading] = useState(false);
  const speechRef = useRef(null);

  // Mapping for root font sizes
  const sizeMap = {
    small: "14px",
    medium: "16px",
    large: "18px",
  };

  // Change global root font size
  const handleTextSizeChange = (size) => {
    setTextSize(size);
    const newSize = sizeMap[size];
    document.documentElement.style.fontSize = newSize;
  };

  // Text-to-speech functionality
  const readText = () => {
    if (isReading) {
      speechSynthesis.cancel();
      setIsReading(false);
      return;
    }

    const textToRead = document.body.innerText;
    const utterance = new SpeechSynthesisUtterance(textToRead);
    speechRef.current = utterance;
    speechSynthesis.speak(utterance);
    setIsReading(true);
  };

  // Set initial size on load
  useEffect(() => {
    document.documentElement.style.fontSize = sizeMap[textSize];
     // eslint-disable-next-line
  }, [textSize]);

  return (
    <footer>
      <div className="myFooter">
        <div className="textSizeControls">
          <button onClick={() => handleTextSizeChange("small")} className="readTextBtn">Small</button>
          <button onClick={() => handleTextSizeChange("medium")} className="readTextBtn">Medium</button>
          <button onClick={() => handleTextSizeChange("large")} className="readTextBtn">Large</button>
        </div>
        <span className="copyright"> &copy; 2025 Bid Brick </span>
        <button className="readTextBtn" onClick={readText}>
          {isReading ? "Stop Reading" : "Read Text"}
        </button>
      </div>
    </footer>
  );
}

